module.exports = __webpack_public_path__ + "static/media/document-week6.50f6715f.pdf";